export default (function() {
  const navigation = document.querySelector('[data-widget="flat2016-nav"]');

  function positionDropdown(trigger, dropdown) {
    if (dropdown.classList.contains('sub-menu__categories') || dropdown.classList.contains('sub-menu__specials') || dropdown.classList.contains('sub-menu__shops')) {
      const triggerRect = trigger.getBoundingClientRect();

      if (!dropdown.classList.contains('sub-menu__shops')) {
        const container = navigation.querySelector('.navigation');
        const containerRect = container ? container.getBoundingClientRect() : { left: 0, top: 0 };
        const centerX = (triggerRect.left - containerRect.left) + (triggerRect.width / 2);
        const top = (triggerRect.bottom - containerRect.top);

        dropdown.style.left = `${centerX}px`;
        dropdown.style.top = `${top}px`;
      } else {
        const topPosition = triggerRect.bottom + window.scrollY;
        if (window.eventLayer?.[0]?.site_id === '100') {
          const leftPosition = triggerRect.left + window.scrollX;
          dropdown.style.left = `${leftPosition}px`;
        }
        dropdown.style.top = `${topPosition}px`;
      }
    }
  }

  function run(){
    if (navigation) {
      const navItems = navigation.querySelector('.navigation');

      const dropdownMenu = navItems?.querySelectorAll('[data-dropdown]');

      dropdownMenu?.forEach(el => {
        const target = document.querySelector(el.dataset.target);
        if(!target) return;

        positionDropdown(el, target);

        [el, target].forEach(item => {
          item.addEventListener('mouseenter', ()=> {
            positionDropdown(el, target);
            target.classList.add('opened');
          });

          item.addEventListener('mouseleave', ()=> {
            target.classList.remove('opened');
          });
        });
      });
    }
  }

  return {
    run: run
  }
})()
